<template>
  <LoginLayout class="complete">
    <h1 class="title">本登録メール送付</h1>
    <p class="discription">ご登録された下記メール宛に本登録確認メールを送付いたしました。</p>
    <p class="address">{{ mailAddress }}</p>
    <p class="important">メールに記載されているURLを30分以内にクリックし、<br />登録を完了させてください。</p>
    <p class="note">
      ※メールが届かない場合は、メールアドレスが間違っている可能性がございます。<br />もう一度ご確認の上、再度お試しください。
    </p>
    <Button :small="this.isSP" primary @click="onSubmit">ログイン画面へ</Button>
  </LoginLayout>
</template>

<script>
import { mapState } from 'vuex'
import LoginLayout from '@/components/templates/LoginLayout'
import Button from '@/components/atoms/Button'

export default {
  name: 'RegistrationComplete',
  components: {
    LoginLayout,
    Button,
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      account: state => state.login.account,
    }),
    mailAddress() {
      return this.account.mailAddress
    },
  },
  methods: {
    onSubmit() {
      window.location.href = this.isSP ? '/sp/login' : '/login/open/'
    },
  },
}
</script>

<style lang="postcss" scoped>
.title {
  font-size: 21px;
  font-weight: bold;
  text-align: center;
}

.discription {
  margin-top: 48px;
}

.address {
  font-weight: bold;
  margin-top: 24px;
}

.important {
  color: var(--pure-red);
  margin-top: 24px;
}

.note {
  font-size: 11px;
  line-height: 1.4;
  margin-top: 16px;
}

.button {
  margin-top: 40px;
}

.responsive {
  @media screen and (max-width: 559px) {
    .title {
      font-size: 16px;
    }

    .discription {
      margin-top: 40px;
    }

    br {
      display: none;
    }
  }
}
</style>
